import { useState, useCallback } from "react";
import Dropdown from "../components/Dropdown";
import CTAs from "./CTAs";
import { exportDataTable } from "../utils/exportUtils";
const DownloadModalTables = ({ onClose, tableData, tag = "" }) => {
  const dropdownContents = [
    { label: "Excel" },
    { label: "CSV" },
    { label: "PDF" },
  ];
  const [selectedFormat, setSelectedFormat] = useState(null);
  const handleDownload = () => {
    if (!selectedFormat) {
      console.error("No format selected!");
      return;
    }
    if (!tableData || tableData.length === 0) {
      console.error("No data available for export!");
      return;
    }

    console.log("Downloading in format:", selectedFormat);
    console.log("Table Data:", tableData);

    exportDataTable(tableData, selectedFormat.label, tag);
    onClose();
  };

  return (
    <div className="relative shadow-[0px_10px_60px_rgba(0,_0,_0,_0.1)] rounded-3xs bg-neutrals-neutral-50 box-border w-full flex flex-col items-start justify-start gap-[24px] text-left text-sm text-neutrals-neutral-900 font-open-sans-ff-meta-strong border-[1px] border-solid border-neutrals-neutral-100">
      <div className="flex flex-col items-start justify-start pt-6 px-6 pb-0 gap-[24px] text-lg">
        <div className="flex flex-row items-start justify-start gap-[292px]">
          <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 flex flex-row items-center justify-center p-2.5 border-[1px] border-solid border-neutrals-neutral-100">
            <img
              className="w-5 relative h-5"
              alt=""
              src="assets/download.svg"
            />
          </div>
          <img
            className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer"
            alt=""
            src="assets/cancel.svg"
            onClick={onClose}
          />
        </div>
        <div className="flex flex-col items-start justify-start gap-[6px]">
          <div className="w-[352px] relative font-semibold inline-block">
            Download options
          </div>
          <div className="w-[352px] relative text-base text-neutrals-neutral-300 inline-block">
            Select the file type.
          </div>
        </div>
      </div>
      <div className="flex flex-col items-start justify-start py-0 px-6">
        <div className="w-[352px] flex flex-col items-start justify-start gap-[10px]">
          <Dropdown
            title="Choose a file format"
            placeholder="Select format"
            width="352px"
            dropdownContents={dropdownContents}
            onSelect={(value) => {
              console.log("Dropdown selection:", value); // Debugging log
              setSelectedFormat(value);
            }}
          />
        </div>
      </div>
      <div className="w-full flex flex-row items-start justify-center pt-0 px-4 md:px-6 pb-6 box-border gap-[24px]">
        <CTAs
          type="Secondarybtn"
          text="Cancel"
          borderColor="border-neutrals-neutral-100"
          position="relative"
          width="w-[140px] md:w-[165px]"
          onClick={onClose}
        />

        <CTAs
          type="Gradientbtn"
          text="Download"
          borderColor="border-primary-primary-500"
          position="relative"
          width="w-[140px] md:w-[165px]"
          onClick={handleDownload}
          disabled={!selectedFormat}
        />
      </div>
    </div>
  );
};

export default DownloadModalTables;
